export class NodeColors {
  public backgroundColors: Array<string> = [
     '#f2623e', '#f1863e', '#f0ac3d', '#efc93d', '#ceef3d', '#63ef3d', '#3defa1', '#3defec', '#3d96ef', '#3f3def', '#bc3def', '#ef3da1', '#ef3d3d',
  ];

  public constantBackground: string = '#3dbfef';

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/classes/node-colors.ts